export default (response: Response) => {
  if (!response.ok) {
    throw response
  }

  return response
}
